import React from 'react';
import { Paper } from '@mui/material';
import styles from './FeatureManager.module.css';
import FeatureTable from './FeatureTable';
import { useGetFeatures } from './api';

export const FeatureList = (): JSX.Element => {
  const { data: features, isError, error } = useGetFeatures();

  if (isError) {
    return <p className="error">{`Error fetching feature list: ${error}`}</p>;
  }

  return (
    <Paper
      role="tabpanel"
      tabIndex={2}
      id="tabpanel-feature_list"
      aria-labelledby="tab-feature_list"
      className={styles.feature}
    >
      <h3>Feature list</h3>
      <FeatureTable features={features} />
    </Paper>
  );
};
